import { __awaiter } from "tslib";
import AjaxUtils from './ajaxUtils';
export const contactDataPointSearch = (searchData) => __awaiter(void 0, void 0, void 0, function* () { return AjaxUtils.post('/api/v2/search', searchData); });
